import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        // minWidth: 120,
        // maxWidth: 300,
        minWidth: 225,
		maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

const names = [
    'Live',
    'Completed',
    'Offline'
];

export default function MultipleSelect(props) {
    const classes = useStyles();

    const handleChange = (event) => {
        props.handleFilterChange(event);
    };

    return (
        <div>
            <FormControl variant="outlined" margin="dense" fullWidth className={classes.formControl} >
                <InputLabel id="demo-simple-select-standard-label">Campaign State</InputLabel>
                <Select
                    fullWidth
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    // multiple
                    value={props.campaignState}
                    name="campaignState"
                    onChange={handleChange}
                    input={<Input />}
                    // renderValue={(selected) => selected.join(', ')}
                    // MenuProps={MenuProps}
                    style={{ width: "225px" }}
                >
                    {names.map((name) => (
                        <MenuItem key={name} value={name} style={{ minHeight: "28px", height: "28px" }}>
                            {/* <Checkbox checked={props.campaignState.indexOf(name) > -1} /> */}
                            {/* <ListItemText primary={name} /> */}
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
